import "lazysizes";
import "lazysizes/plugins/aspectratio/ls.aspectratio";

import LazyPreloader from "./../components/lazy-preloader/presenter/lazy-preloader.js";

const lazyPreloaderComponent = new LazyPreloader();
lazyPreloaderComponent.init();
